import PropTypes from 'prop-types';
import { extendObservable } from 'mobx';
import AdministratorsStore from '../Administrators/AdministratorsStore';
import { apiCall } from '../../API';
import { ROLE_FULL_ACCESS, ROLE_READ_ONLY } from '../Administrators/AdministratorModalStore';

export default class LocalAccountsStore {
    static PropType = PropTypes.shape({
        admins: AdministratorsStore.PropType.isRequired,
    });

    constructor(data = {}) {
        extendObservable(this, /** @class LocalAccountsStore */{
            admins: new AdministratorsStore({
                possibleRoles: [ROLE_FULL_ACCESS, ROLE_READ_ONLY],
                apiList: apiCall('/console/admin_user/list', { isUserAction: false }),
                apiCreate: apiCall('/console/admin_user/create', { isUserAction: true }),
                apiUpdate: apiCall('/console/admin_user/update', { isUserAction: true }),
                apiDelete: apiCall('/console/admin_user/delete', { isUserAction: true }),
                apiInvitation: apiCall('/console/admin_user/send_invitation', { isUserAction: true }),
            }),
        }, data);
    }
}

